// Configuration Directus
export const DIRECTUS_CONFIG = {
  url: 'https://services.dingo.tn',
  token: 'dU79s-YCZFh_Aq7605ZI1hGp5paXHLIi', // À remplacer par votre token
  endpoints: {
    contacts: '/items/contacts_notifications'
  }
}; 